// COMMON INPUT STYLES
import TextField from '@mui/material/TextField';
import styled from '@emotion/styled';
import setMargin from '../../helpers/set-margin';

export const commonStyle = `
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 150%;
`;

export const commonBorderStyle = ({ theme }) => `
  border: none;
  border-radius: ${theme.borders.radius};
`;

export const placeholderStyle = ({ theme, placeholderColor }) => `

  ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    ${commonStyle};
    font-family: 'BasicCommercial', sans-serif;
    color: ${
      placeholderColor
        ? theme.colors[placeholderColor] || placeholderColor
        : theme.colors.neutral80
    };
  }
  ::-moz-placeholder { /* Firefox 19+ */
    ${commonStyle};
    font-family: 'BasicCommercial', sans-serif;
    color: ${
      placeholderColor
        ? theme.colors[placeholderColor] || placeholderColor
        : theme.colors.neutral80
    };
  }
  :-ms-input-placeholder { /* IE 10+ */
    ${commonStyle};
    font-family: 'BasicCommercial', sans-serif;
    color: ${
      placeholderColor
        ? theme.colors[placeholderColor] || placeholderColor
        : theme.colors.neutral80
    };
  }
  :-moz-placeholder { /* Firefox 18- */
    ${commonStyle};
    font-family: 'BasicCommercial', sans-serif;
    color:${
      placeholderColor
        ? theme.colors[placeholderColor] || placeholderColor
        : theme.colors.neutral80
    };
  }
`;

export const Field = styled.div`
  ${setMargin};
  width: ${({ w }) => w || '100%'};
  opacity: ${({ disabled }) => (disabled ? '0.5' : '1')};
  padding-bottom: ${({ theme }) => theme.spacings[2]};
  width: 100%;
`;

export const Label = styled.label`
  ${setMargin};
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  min-height: 40px;
  align-items: flex-end;
  padding-bottom: ${({ theme }) => theme.spacings[1]};
`;

export const HelperWrapper = styled.div`
  padding-bottom: ${({ theme }) => theme.spacings[2]};
`;

export const OptionalTag = styled.span`
  ${setMargin};
  display: inline-block;
  font-weight: 400 !important;
  font-size: 16px;
  line-height: 1.7;
  color: ${({ theme }) => theme.colors.neutral.shades.shade400};
`;

export const StyledTextField = styled(TextField)`
  width: 100%;
  height: 50px;
  background: none;
  font-size: 1rem;

  & .MuiOutlinedInput-root {
    color: ${({ theme }) => theme.colors.neutral.shades.shade700};

    & fieldset {
      border: ${({ theme, error }) =>
        `2px solid ${error ? theme.colors.red.shades.shade600 : theme.colors.neutral.shades.shade700}`};
      border-radius: 8px;
    }
    &:hover fieldset {
      border-color: ${({ theme }) => theme.colors.neutral.shades.shade700};
    }
    &.Mui-focused fieldset {
      border-color: ${({ theme }) => theme.colors.blue.shades.shade600};
    }
  }

  & .MuiOutlinedInput-input {
    padding-left: 16px;
    padding-right: 16px;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.neutral.shades.shade700};

    ::placeholder {
      opacity: 1;
      font-size: 16px;
      font-weight: 300;
      padding-left: 2px;
      -webkit-text-fill-color: ${({ theme }) =>
        theme.colors.neutral.shades.shade600};
    }
  }

  .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root.Mui-disabled
    .MuiOutlinedInput-notchedOutline {
    border-color: ${({ theme }) => theme.colors.black};
    color: ${({ theme }) => theme.colors.black};
  }

  ${({ theme }) => theme.media.mobile} {
    width: 100%;
  }
`;
